import { Moment } from 'moment';

import { ItemActionBase } from 'app/buffer-graph/models/item-actions/item-action-base';
import { FreshItemActionLine } from 'app/buffer-graph/models/item-actions/fresh-item-action-line';

export class FreshItemActionHeader extends ItemActionBase {
    constructor(
        id: string,
        actionSeason: string,
        status: string,
        purchaseDate: string,
        //purchaseDate: Moment,
        startDate: string,
        //startDate: Moment,
        endDate: string,
        //endDate: Moment,
        saleChangeRatio: string/*number*/,
        saleIncrease: string/*number*/,
        replenishment: string,
        actionOut: string,
        importDate: string,
        //importDate: Moment,
        documentNumber: string,
        public readonly lines: FreshItemActionLine[]) {
        super(id,
            actionSeason,
            status,
            purchaseDate,
            startDate,
            endDate,
            saleChangeRatio,
            saleIncrease,
            replenishment,
            actionOut,
            importDate,
            documentNumber);
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/item-actions/fresh-item-action-header.ts